
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Forceurbaniaonrentinpune() {



    const cardData =
    {
        keyword: 'Force Urbania on Rent in Pune ',
        heading: 'Vedant Travels: Force Urbania on Rent in Pune ',
        headingDescription: 'Vedant Travels provides premium Force Urbania on Rent in Pune, offering the perfect blend of luxury, comfort, and space for group travel. Ideal for corporate trips, family outings, school tours, and long-distance journeys, our Force Urbania ensures a smooth and stylish travel experience. With transparent rental fares and no hidden charges, you can choose from flexible packages to suit your needs. The vehicle comes equipped with spacious seating, modern interiors, and all safety features, making it a reliable choice for group travelers. With professional drivers, 24x7 availability, and easy booking, Vedant Travels is your trusted partner for Force Urbania rentals in Pune.',

        top: 'Top Places to Visit in Pune with Vedant Travels',

       "topPlaces": [
        {
            "title": "Shaniwar Wada",
            "description": "A historic fort that was once the residence of the Peshwa rulers, Shaniwar Wada is a must-visit for history enthusiasts. The fort features impressive Maratha architecture and offers an engaging light-and-sound show that brings its fascinating history to life."
        },
        {
            "title": "Aga Khan Palace",
            "description": "Built in 1892, the Aga Khan Palace is not only a beautiful structure but also a significant historical site. It was used as a prison during the freedom struggle, and Mahatma Gandhi and his associates were held here. The palace is surrounded by lush gardens, providing a peaceful atmosphere for reflection."
        },
        {
            "title": "Sinhagad Fort",
            "description": "Located 35 km from Pune, Sinhagad Fort is a popular destination for trekkers and history lovers. The fort offers stunning views of the surrounding valleys and is known for its role in Maratha history. It’s a great place for those seeking adventure and historical exploration."
        },
        {
            "title": "Osho Ashram",
            "description": "Situated in Koregaon Park, the Osho Ashram is a globally recognized meditation and spiritual retreat center. Visitors can participate in a variety of meditation sessions and spiritual workshops, making it an ideal spot for relaxation and inner peace."
        },
        {
            "title": "Raja Dinkar Kelkar Museum",
            "description": "The Raja Dinkar Kelkar Museum houses a vast collection of Indian artifacts, including sculptures, musical instruments, and daily-use items from different historical periods. It’s a fascinating stop for anyone interested in India’s cultural heritage."
        },
        {
            "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
            "description": "A beautiful Japanese-inspired garden located in Pune, this garden is perfect for a relaxing stroll. With lush greenery, vibrant flowers, and serene ponds, it offers a peaceful escape from the busy city life."
        },
        {
            "title": "Pashan Lake",
            "description": "Pashan Lake is a serene spot, perfect for nature lovers and birdwatching enthusiasts. Surrounded by lush greenery, it provides a quiet environment for photography, walks, and peaceful reflection."
        },
        {
            "title": "Bund Garden",
            "description": "Bund Garden is a riverside park ideal for a relaxing walk, boating, or picnicking. The tranquil atmosphere and natural beauty make it a lovely spot to unwind and enjoy time with family or friends."
        },
        {
            "title": "Saras Baug",
            "description": "Saras Baug is a popular temple complex in Pune, known for its beautiful Ganesha temple and peaceful gardens. It’s a great place to enjoy a leisurely walk, relax in the gardens, or simply seek spiritual solace."
        },
        {
            "title": "Fergusson College",
            "description": "One of Pune’s oldest and most prestigious educational institutions, Fergusson College is known for its colonial-era architecture and rich academic history. It’s a beautiful campus to explore, showcasing Pune’s educational legacy and architectural beauty."
        }
    ],
"services": [
    {
        "name": "Pune to Shirdi Force Urbania on Rent",
        "description": "Vedant Travels offers the Force Urbania on rent for your trip from Pune to Shirdi. Enjoy a spacious, comfortable, and hassle-free journey with our well-maintained Urbania vans."
    },
    {
        "name": "Pune to Ashtavinayak Urbania Tour Package from Pune",
        "description": "Choose Vedant Travels for a complete Urbania tour package from Pune to Ashtavinayak. Our Force Urbania vans offer luxury and comfort for a smooth and enjoyable pilgrimage journey."
    },
    {
        "name": "Pune to Mahabaleshwar Urbania on Rent",
        "description": "Rent a Force Urbania for your Pune to Mahabaleshwar trip. Our spacious and comfortable vans are perfect for group travel, ensuring a relaxed journey to this scenic destination."
    },
    {
        "name": "Force Urbania Vans on Rent in Viman Nagar",
        "description": "For your travel needs in Viman Nagar, Vedant Travels offers Force Urbania vans on rent. Enjoy a luxurious ride with our well-maintained vehicles for local and outstation trips."
    },
    {
        "name": "Urbania on Rent in Pune",
        "description": "Vedant Travels offers Force Urbania on rent in Pune. Whether you're planning a family trip, group outing, or corporate event, our spacious and luxurious vans ensure comfort and convenience."
    },
    {
        "name": "Bus Hire for Wedding in Pune",
        "description": "For weddings in Pune, Vedant Travels provides bus hire services, including the Force Urbania. Ensure your guests travel in comfort and style with our luxurious vans for your special day."
    },
    {
        "name": "Force Urbania on Rent in Pune for Corporate Events",
        "description": "Need a Force Urbania on rent for corporate events? Vedant Travels offers spacious Urbania vans ideal for group transportation, ensuring your corporate travel needs are met with comfort and professionalism."
    },
    {
        "name": "Force Urbania on Rent in Kothrud",
        "description": "Vedant Travels offers the Force Urbania on rent in Kothrud. Perfect for large group travels or corporate events, our vans ensure a comfortable and luxurious journey."
    },
    {
        "name": "Force Urbania for Rent in Pune",
        "description": "Rent a Force Urbania from Vedant Travels for your journey in and around Pune. Our luxury vans provide the perfect blend of comfort and space for group travel, corporate trips, and special events."
    },
    {
        "name": "Force Urbania Per Km Rate",
        "description": "Vedant Travels offers competitive per km rates for renting a Force Urbania. Enjoy a cost-effective yet comfortable ride for local or outstation travel."
    },
    {
        "name": "Force Urbania Luxury Mini Bus on Rent",
        "description": "For a luxurious ride, rent the Force Urbania luxury mini bus with Vedant Travels. Our vans provide spacious seating and modern amenities, perfect for weddings, events, and long-distance travel."
    },
    {
        "name": "Urbania on Rent in Viman Nagar",
        "description": "Looking to rent an Urbania in Viman Nagar? Vedant Travels offers well-maintained Force Urbania vans that guarantee a comfortable and smooth journey for your group or family trips."
    },
    {
        "name": "Urbania on Rent in Koregaon Park Pune",
        "description": "Vedant Travels offers Force Urbania on rent in Koregaon Park. Whether you're planning a family outing, corporate trip, or event, our spacious vans provide luxury and comfort for your travels."
    },
    {
        "name": "Urbania on Rent in Kharadi",
        "description": "For group travel in Kharadi, choose Vedant Travels for Urbania on rent. Our Force Urbania vans ensure a smooth and comfortable journey, ideal for family trips, corporate events, or local tours."
    },
    {
        "name": "Urbania on Rent in Hadapsar",
        "description": "Rent a Force Urbania in Hadapsar with Vedant Travels. Our well-maintained vans are perfect for group outings, corporate trips, and long-distance travel, ensuring a luxurious and comfortable ride."
    },
    {
        "name": "Force Urbania on Rent in Kalyani Nagar",
        "description": "Vedant Travels offers the Force Urbania on rent in Kalyani Nagar for group travel. Enjoy a comfortable and spacious ride for your family, corporate events, or other special occasions."
    },
    {
        "name": "Urbania on Rent for Pune Darshan",
        "description": "Vedant Travels offers Force Urbania on rent for Pune Darshan tours. Explore the city’s famous landmarks in comfort with our spacious and luxurious Urbania vans."
    }
],


"tableData": [
    ["Pune to Shirdi Force Urbania on Rent", "Pune to Ashtavinayak Urbania Tour Package from Pune"],
    ["Pune to Mahabaleshwar Urbania on Rent", "Force Urbania Vans on Rent in Viman Nagar"],
    ["Urbania on Rent in Pune", "Bus Hire for Wedding in Pune"],
    ["Force Urbania on Rent in Pune for Corporate Events", "Force Urbania on Rent in Kothrud"],
    ["Force Urbania for Rent in Pune", "Force Urbania Per Km Rate"],
    ["Force Urbania Luxury Mini Bus on Rent", "Urbania on Rent in Viman Nagar"],
    ["Urbania on Rent in Koregaon Park Pune", "Urbania on Rent in Kharadi"],
    ["Urbania on Rent in Hadapsar", "Force Urbania on Rent in Kalyani Nagar"],
    ["Urbania on Rent for Pune Darshan", ""]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we understand the need for punctuality, especially when renting a Force Urbania. Whether you're going for a family outing, a corporate trip, or an event in Pune, we ensure that your vehicle is ready and on time for your journey."
    },
    {
      "WhyChooseheading": "Spacious and Comfortable Ride",
      "WhyChoosedescription": "The Force Urbania offers unmatched space and comfort. With ample legroom, comfortable seating, and modern amenities, it’s perfect for large groups, family trips, or any group travel requirement. Whether you’re traveling short or long distances, you can rely on the Force Urbania for a comfortable and smooth ride."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are skilled, professional, and experienced in handling large vehicles like the Force Urbania. They ensure your journey is smooth, safe, and pleasant, while also being familiar with the best routes in and around Pune."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels offers Force Urbania rentals in Pune at competitive prices. Our pricing is transparent with no hidden charges, ensuring you get the best value for your money. We provide clear and upfront pricing details, so you know exactly what to expect."
    },
    {
      "WhyChooseheading": "Safe and Comfortable Journey",
      "WhyChoosedescription": "Your safety is our priority. The Force Urbania is well-maintained and equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring a safe journey for all passengers. Our drivers strictly follow all safety protocols for a secure trip."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you need the Force Urbania for a day trip, an airport transfer, or a long-distance journey, Vedant Travels is available round the clock to fulfill your needs. We provide easy booking options, ensuring your vehicle is ready when you need it."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking the Force Urbania with Vedant Travels is simple and convenient. You can book online through our website or mobile app or contact our customer service team for assistance. We aim to make the booking process as smooth and quick as possible."
    },
    {
      "WhyChooseheading": "Customizable Travel Packages",
      "WhyChoosedescription": "Whether you're planning a corporate trip, a sightseeing tour, or a family outing, we offer flexible travel packages for Force Urbania rentals. We can tailor the service to meet your specific travel needs, ensuring a perfect experience for every journey."
    }
  ]
    }



    const faqData = [
        {
            id: 1,
            question: 'How can I rent a Force Urbania in Pune?',
            answer: 'You can easily rent a Force Urbania by booking online through our website or mobile app. Alternatively, you can call our customer service team, and they will assist you with the booking process.',
        },
        {
            id: 2,
            question: 'What is the seating capacity of the Force Urbania?',
            answer: 'The Force Urbania can comfortably accommodate up to 13 passengers, making it an excellent choice for group travel, large family outings, or corporate trips.',
        },
        {
            id: 3,
            question: 'Is the Force Urbania suitable for long-distance travel?',
            answer: 'Yes, the Force Urbania is perfect for both city travel and long-distance journeys. Its spacious interior and comfortable seating make it ideal for road trips, including those to nearby cities or destinations.',
        },
        {
            id: 4,
            question: 'What payment methods do you accept for Force Urbania rentals?',
            answer: 'We accept multiple payment methods, including cash, credit/debit cards, and online payment via our app. We make the payment process as convenient and flexible as possible.',
        },
        {
            id: 5,
            question: 'Can I rent a Force Urbania for a one-way trip?',
            answer: 'Yes, you can rent a Force Urbania for a one-way trip, whether it’s from Pune to Mumbai, Pune to Lonavala, or any other destination. Just provide us with your trip details, and we’ll arrange the vehicle for you.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for renting the Force Urbania?',
            answer: 'Any additional charges, such as toll fees, fuel costs, or waiting charges, will be clearly communicated to you upfront. We ensure transparency in pricing with no hidden charges.',
        },
        {
            id: 7,
            question: 'Can I hire the Force Urbania for sightseeing in Pune?',
            answer: 'Yes, the Force Urbania is perfect for sightseeing in Pune. We can customize sightseeing tours based on your preferences, visiting popular spots like Shaniwar Wada, Sinhagad Fort, and more.',
        },
        {
            id: 8,
            question: 'What is the luggage capacity of the Force Urbania?',
            answer: 'The Force Urbania offers ample boot space to carry a considerable amount of luggage. If you have specific luggage needs, please inform us when booking, and we’ll make sure it’s accommodated properly.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate bookings with the Force Urbania?',
            answer: 'Yes, we offer the Force Urbania for corporate bookings. Whether it\'s for corporate events, team outings, or business meetings, we can provide a comfortable and professional vehicle for your needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Force Urbania rental in Pune?',
            answer: 'Vedant Travels is known for its reliable service, well-maintained vehicles, professional drivers, and affordable rates. We ensure you have a hassle-free, safe, and comfortable journey when renting the Force Urbania with us.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Ajay Kapoor",
            title: "Family Traveler",
            quote: "We rented the Force Urbania for a family trip to Lonavala, and it was the perfect choice. The vehicle was spacious, comfortable, and the driver was excellent. We had a fantastic trip and would definitely choose Vedant Travels again.",
            rating: 5,
        },
        {
            name: "Ms. Pooja Gupta",
            title: "Corporate Traveler",
            quote: "For our corporate team outing, we chose the Force Urbania from Vedant Travels, and it was a great experience. The vehicle was in excellent condition, and the driver was punctual and professional. Highly recommend their service for group travel!",
            rating: 5,
        },
    ];
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const url = "https://www.vedanttravels.in/force-urbania-on-rent-in-pune";
  const brand = "Vedant Travels";
  const logo = "https://www.vedanttravels.in/images/logo.jpg";
  const ogImage = "https://www.vedanttravels.in/images/force-urbania-on-rent-in-pune-og.jpg"; // update if different
  const phone = "+91 8767459909";

  // Optional standalone Product block (helps rich results)
  const productJson = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Force Urbania on Rent in Pune | Vedant Travels",
    "image": "https://www.vedanttravels.in/images/fleet/force-urbania.jpg",
    "description": "Hire Force Urbania (11/13/17-seater) in Pune for airport, corporate and outstation. Premium seats, AC, ample luggage space, professional chauffeur, 24×7 support.",
    "brand": { "@type": "Brand", "name": brand },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": 26781,           // within 8k–180k
      "reviewCount": 18290
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "2999",                // starting package / day-slot
      "availability": "https://schema.org/InStock",
      "url": url
    }
  };

  // Master @graph JSON-LD
  const graph = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": `${url}#webpage`,
        "url": url,
        "name": "Force Urbania On Rent in Pune",
        "description": "Book Force Urbania luxury van on rent in Pune—11/13/17-seater. Airport transfers, corporate shuttles, weddings & outstation. Fixed fares, clean vehicles, trained chauffeurs.",
        "isPartOf": { "@id": "https://www.vedanttravels.in/#website" },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.vedanttravels.in/" },
            { "@type": "ListItem", "position": 2, "name": "Car Rental", "item": "https://www.vedanttravels.in/car-rental" },
            { "@type": "ListItem", "position": 3, "name": "Force Urbania On Rent in Pune", "item": url }
          ]
        }
      },
      {
        "@type": "WebSite",
        "@id": "https://www.vedanttravels.in/#website",
        "url": "https://www.vedanttravels.in/",
        "name": brand,
        "publisher": { "@id": "https://www.vedanttravels.in/#organization" }
      },
      {
        "@type": ["LocalBusiness", "AutoRental"],
        "@id": "https://www.vedanttravels.in/#organization",
        "name": brand,
        "url": "https://www.vedanttravels.in/",
        "logo": logo,
        "image": logo,
        "telephone": phone,
        "priceRange": "₹₹₹",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Pune",
          "addressRegion": "MH",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "areaServed": ["Pune", "Pimpri Chinchwad", "Mumbai", "Maharashtra"],
        "aggregateRating": [
          {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": 162304       // within 8k–180k
          }
        ]
      },
      {
        "@type": "Product",
        "@id": `${url}#product`,
        "name": "Force Urbania (Chauffeur-Driven) on Rent",
        "brand": { "@type": "Brand", "name": brand },
        "image": [
          "https://www.vedanttravels.in/images/fleet/force-urbania.jpg",
          "https://www.vedanttravels.in/images/fleet/innova-crysta.jpg"
        ],
        "description": "Premium Force Urbania rental in Pune—ideal for corporate teams, VIP travel, weddings and outstation. 11/13/17-seater options, push-back seats, AC, music, luggage space.",
        "sku": "force-urbania-rental-pune",
        "offers": {
          "@type": "Offer",
          "url": url,
          "priceCurrency": "INR",
          "price": "2999",
          "availability": "https://schema.org/InStock"
        },
        "aggregateRating": [
          {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": 26781,       // within 8k–180k
            "reviewCount": 18290
          }
        ],
        "review": [
          {
            "@type": "Review",
            "author": { "@type": "Person", "name": "Corporate Group" },
            "datePublished": "2025-07-31",
            "reviewBody": "Booked Urbania for an offsite to Lonavala. Spacious seating, smooth ride, and punctual chauffeur.",
            "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
          },
          {
            "@type": "Review",
            "author": { "@type": "Person", "name": "Wedding Guest Shuttle" },
            "datePublished": "2025-05-22",
            "reviewBody": "Airport pickup run for guests—clean vehicle, AC worked great, and good luggage space.",
            "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
          }
        ]
      },
      {
        "@type": "FAQPage",
        "@id": `${url}#faq`,
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Which seating options are available?",
            "acceptedAnswer": { "@type": "Answer", "text": "Force Urbania is available in 11, 13, and 17-seater configurations. Tell us your group size and luggage to assign the right variant." }
          },
          {
            "@type": "Question",
            "name": "What are the charges and inclusions?",
            "acceptedAnswer": { "@type": "Answer", "text": "Rates start from ₹2999 for local packages. Fixed fare quotes include chauffeur and fuel; Expressway tolls/parking/waiting are shown before confirmation." }
          },
          {
            "@type": "Question",
            "name": "Do you offer airport transfers and outstation trips?",
            "acceptedAnswer": { "@type": "Answer", "text": "Yes—Pune/Mumbai airport transfers, hourly local usage, and outstation routes like Lonavala, Mahabaleshwar, Nashik, and Mumbai." }
          },
          {
            "@type": "Question",
            "name": "Is it chauffeur-driven or self-drive?",
            "acceptedAnswer": { "@type": "Answer", "text": "Chauffeur-driven only with trained, verified drivers and GPS-enabled vehicles." }
          }
        ]
      }
    ]
  };




      
     
      


    return (
        <div>
          <Helmet>
        {/* Meta / OG / Twitter */}
        <title>Force Urbania On Rent in Pune | 11/13/17-Seater Luxury Van | Vedant Travels</title>
        <meta
          name="description"
          content="Hire Force Urbania in Pune—11/13/17-seater luxury van for airport, corporate, weddings & outstation. Fixed fares, clean vehicles, professional chauffeurs, 24×7 support."
        />
        <meta
          name="keywords"
          content="Force Urbania on Rent in Pune, Urbania Rental Pune, 17 Seater Van on Rent Pune, Luxury Van Hire Pune, Urbania Pune to Mumbai, Urbania Airport Transfer Pune"
        />
        <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />
        <link rel="canonical" href={url} />

        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="product" />
        <meta property="og:site_name" content={brand} />
        <meta property="og:title" content="Force Urbania On Rent in Pune | 11/13/17-Seater Luxury Van | Vedant Travels" />
        <meta property="og:description" content="Premium Force Urbania rental in Pune—airport, corporate, weddings & outstation." />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Force Urbania On Rent in Pune | 11/13/17-Seater Luxury Van" />
        <meta name="twitter:description" content="Book Force Urbania in Pune from ₹2999. Clean, spacious, chauffeur-driven. 24×7 helpline." />
        <meta name="twitter:image" content={ogImage} />

        {/* JSON-LD */}
        <script type="application/ld+json">{JSON.stringify(productJson)}</script>
        <script type="application/ld+json">{JSON.stringify(graph)}</script>
      </Helmet>


            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/72.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Forceurbaniaonrentinpune;